export default __webpack_public_path__ + "static/media/apple.6400a355.gif";